import { ChangeCartContactPayload } from '@spa/lib/store/carts/cartsSlice';
import { ChangeCartContactResult } from '../../../graphql/cart/changeCartContact';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartContactRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly contact: ChangeCartContactPayload;
  readonly parentActionId: number;
}
export const apiCartChangeCartContactRequestedType = 'api/cart/changeCartContact--requested';
export const apiCartChangeCartContactRequested =
  createAction<ApiCartChangeCartContactRequestedPayload>(apiCartChangeCartContactRequestedType);
export type ApiCartChangeCartContactRequestedAction = ReturnType<
  typeof apiCartChangeCartContactRequested
>;

export interface ApiCartChangeCartContactSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartContactResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartContactSucceededType = 'api/cart/changeCartContact--succeeded';
export const apiCartChangeCartContactSucceeded =
  createAction<ApiCartChangeCartContactSucceededPayload>(apiCartChangeCartContactSucceededType);
export type ApiCartChangeCartContactSucceededAction = ReturnType<
  typeof apiCartChangeCartContactSucceeded
>;

export interface ApiCartChangeCartContactFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartContactFailedType = 'api/cart/changeCartContact--failed';
export const apiCartChangeCartContactFailed = createAction<ApiCartChangeCartContactFailedPayload>(
  apiCartChangeCartContactFailedType
);
export type ApiCartChangeCartContactFailedAction = ReturnType<
  typeof apiCartChangeCartContactFailed
>;
